<template>



<div  style="text-align: center; max-width:900px; margin-top: 50px">

  <section  style="
  
  background-color: #ececec;
  padding-top: 50px;
  padding:20px;
  padding-bottom: 30px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius:15px;
  ">
  <h3>Recién vistos o sugeridos</h3>

  <div class="container">

        <div class="row" style="justify-content: center; display:block;">

            <div v-if="!loaded" style="height:300px">
                  <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
            </div>
 

            <div v-if="cursos.length == 0 && loaded">
            <h5 class="card-title subtitulo">Aún no viste ninguna actividad</h5>
            <img src="public/images/site/background-no-activity.svg" style="max-width:600px" id="challenges" alt="sin actividad"/>
            </div>

            <div v-if="loaded" class="container">
                <div class="row" style="justify-content: center" >
                    <app-activity v-for="(activity,index) in cursos" :activity="activity" v-bind:key ="index"> </app-activity>
                </div>
            </div>

        </div>
  </div>




  

</section>




<img
src="public/images/site/paint-grey.svg"
id="challenges"
alt="Miles de proyectos"
style=" margin-left: 20px;
margin-right: 20px;"
/>

</div>

</template>


<script>
import Activities from '../activities/Activity';
import { mapGetters } from 'vuex'

export default {
    data: function() {
        return{
            loaded:false,
            perfil:"",
            cursos:"",
        }
    },
    computed:{
        ...mapGetters([
            'categorias',
            'userLogged',
            'pathAPI'
            ]),

        },
    methods: {
           buscarPerfil() {
            var self = this
            fetch(
            self.pathAPI+"perfil_usuario.php?usuario=" +
                self.userLogged.user
            )
        .then(response => response.json())
        .then(data => {
                self.cursos = data.cursos_pendientes
                self.loaded = true


        });
        }
    },
    mounted: function(){
        this.buscarPerfil()


    },
    components:{
        appActivity : Activities
    }
}
</script>

<style scoped>
.alias{
    background: rgb(236, 236, 236);
    border-radius: 30px;
    margin: auto;
    width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/ContinueWatching.vue